import '/node_modules/@teamworksdev/vuetify/dist/src/styles/main.scss';
import '@/styles/main.scss';
import { getVuetifyConfig } from '@/plugins/vuetify';
import { getVuetify } from '@teamworksdev/vuetify';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './AppSign.vue';
import { getRouter } from './router';
import { i18n } from './plugins/i18n';
import { initDatadog } from './plugins/datadog';

initDatadog('contracts-public');

const app = createApp(App);

const vuetify = getVuetify(getVuetifyConfig({ theme: true }));

app.use(vuetify);
app.use(i18n);
app.use(createPinia());
app.use(getRouter());

app.mount('#app');
